import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import CompactToggle from '~/components/toolbar/shared/CompactToggle';
import { useSwitchLineMode } from '~/hooks/viewer/useSwitchLineMode';
import { lineOptionsState } from '~/state/atoms/toolsAtoms';

export default function LineToolOptions() {
    const lineOptions = useRecoilValue(lineOptionsState);
    const switchLineMode = useSwitchLineMode();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
            }}
        >
            <CompactToggle
                labelId="toolbar.contouring.erase"
                tooltipId="toolbar.contouring.erase.tooltip"
                value={lineOptions.mode === 'erase'}
                onChange={(erase) =>
                    switchLineMode(() => (erase ? 'erase' : 'draw'))
                }
            />
        </Box>
    );
}
